// removed by extract-text-webpack-plugin
module.exports = {"ContentCard":"ContentCard__ContentCard___qhfzz","LeftSide":"ContentCard__LeftSide___2yyUD","LeftSideHeading":"ContentCard__LeftSideHeading___d6DMi","RightSide":"ContentCard__RightSide___1gAon"};


//////////////////
// WEBPACK FOOTER
// ./src/AtomicContainers/ContentCard/ContentCard.less
// module id = 1134
// module chunks = 0 1